import React from 'react';
import Dialog, {
	DialogTitle,
	DialogContent,
	DialogActions,
} from '../common/Dialog';
import Button from '../common/buttons/Button';
import { Typography } from '@mui/material';
import { CompanyExternalUser } from '../../data/models/companyExternalUser';
import Modal from '../common/Modal';

interface UnarchiveExternalUserConfirmationModalProps {
	open: boolean;
	handleClose: () => void;
	user: CompanyExternalUser | undefined;
	onConfirm: () => void;
}

const UnarchiveExternalUserConfirmationModal: React.FC<
	UnarchiveExternalUserConfirmationModalProps
> = ({ open, handleClose, user, onConfirm }) => {
	if (!user) return null;

	const handleConfirm = () => {
		onConfirm();
		handleClose();
	};

	return (
		<Modal open={open} handleClose={handleClose}>
			<DialogTitle>Unarchive External User</DialogTitle>
			<DialogContent>
				<Typography variant="body1" gutterBottom>
					Are you sure you want to unarchive{' '}
					<strong>
						{user.firstName} {user.lastName}
					</strong>{' '}
					({user.email})?
				</Typography>
				<Typography
					variant="body2"
					color="text.secondary"
					sx={{ mt: 2 }}
				>
					Unarchiving this external user will allow them to be added
					to projects and groups again. They will need to be invited
					again to regain access to the platform.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} variant="text" color="inherit">
					Cancel
				</Button>
				<Button
					onClick={handleConfirm}
					variant="contained"
					color="primary"
				>
					Unarchive User
				</Button>
			</DialogActions>
		</Modal>
	);
};

export default UnarchiveExternalUserConfirmationModal;
